import { render, staticRenderFns } from "./OTPLogin.vue?vue&type=template&id=28e0480c&"
import script from "./OTPLogin.vue?vue&type=script&lang=js&"
export * from "./OTPLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports